import React from 'react';
import {useTranslation} from "react-i18next";
import {observer} from "mobx-react-lite";

const NoResult = () => {
  const { t } = useTranslation();

  return (
      <div className="not_found">
        <span>{t('No results')}</span>
      </div>
  );
};

export default observer(NoResult);